import type { zoomError } from '@lib/zoom/types';
import {
  ZOOM_VALIDATION_ERROR,
  ZOOM_REGISTRATION_ERROR_CODE,
  EMPTY_LINK_ERROR_CODE,
  INVALID_LINK_ERROR_CODE,
  REGISTRATION_LINK_ERROR_CODE,
  EVENT_LINK_ERROR_CODE
} from '@lib/zoom/constants';

type ZoomErrorCodes = Record<number | string, zoomError>;

export const ZOOM_ERROR_CODES: ZoomErrorCodes = {
  200: {
    type: 'JOIN_MEETING_FAILED',
    reason: 'Not support start meeting via tokens',
    errorCode: 200,
    message: 'This meeting/webinar requires zoom authentication. Please add the current authorized user as an alternative host.',
    helpUrl: 'https://help.streamalive.com/en/articles/11332308-streamalive-zoom-connection-troubleshooting-guide#h_3c6e40fb98'
  },
  3707: {
    type: 'JOIN_MEETING_FAILED',
    reason: 'The meeting number is not found.',
    errorCode: 3707,
    message: 'Zoom reported a connection error: The meeting number is not found.',
    helpUrl: 'https://help.streamalive.com/en/articles/11332308-streamalive-zoom-connection-troubleshooting-guide#h_53650a9b0b',
  },
  3009: {
    type: 'JOIN_MEETING_FAILED',
    reason: 'Be removed.',
    errorCode: 3009,
    message: 'Zoom reported a connection error: The bot may have been manually removed.',
    helpUrl: 'https://help.streamalive.com/en/articles/11332308-streamalive-zoom-connection-troubleshooting-guide#h_2bf3c65265'
  },
  3051: {
    type: 'JOIN_MEETING_FAILED',
    reason: 'Require login',
    errorCode: 3051,
    message: 'Please authorize your Zoom account on StreamAlive.',
    helpUrl: 'https://help.streamalive.com/en/articles/11332308-streamalive-zoom-connection-troubleshooting-guide#h_3c6e40fb98'
  },
  3099: {
    type: 'JOIN_MEETING_FAILED',
    reason: 'This webinar requires registration.',
    errorCode: 3099,
    message: 'This webinar requires manual registration. Please paste the meeting link after registering.',
    helpUrl: 'https://help.streamalive.com/en/articles/11332308-streamalive-zoom-connection-troubleshooting-guide#h_92f7a955f9'
  },
  [ZOOM_REGISTRATION_ERROR_CODE]: {
    type: 'ERR_BAD_REQUEST',
    reason: 'Zoom Registration Error',
    errorCode: ZOOM_REGISTRATION_ERROR_CODE,
    message: 'This meeting requires manual registration. Please paste the meeting link after registering.',
    helpUrl: 'https://help.streamalive.com/en/articles/11332308-streamalive-zoom-connection-troubleshooting-guide#h_92f7a955f9'
  },
  [EMPTY_LINK_ERROR_CODE]: {
    type: ZOOM_VALIDATION_ERROR,
    reason: 'Empty Meeting Link Entered',
    errorCode: EMPTY_LINK_ERROR_CODE,
    message: 'Please enter a meeting link.',
    helpUrl: 'https://help.streamalive.com/en/articles/11332308-streamalive-zoom-connection-troubleshooting-guide#h_93f2bc2ec9'
  },
  [INVALID_LINK_ERROR_CODE]: {
    type: ZOOM_VALIDATION_ERROR,
    reason: 'Invalid Link Entered',
    errorCode: INVALID_LINK_ERROR_CODE,
    message: 'Please enter a valid meeting or webinar link.',
    helpUrl: 'https://help.streamalive.com/en/articles/11332308-streamalive-zoom-connection-troubleshooting-guide#h_142cd2ca0f'
  },
  [REGISTRATION_LINK_ERROR_CODE]: {
    type: ZOOM_VALIDATION_ERROR,
    reason: 'Registration Link Entered',
    errorCode: REGISTRATION_LINK_ERROR_CODE,
    message: 'This is a registration link. Please enter a meeting or webinar link.',
    helpUrl: 'https://help.streamalive.com/en/articles/11332308-streamalive-zoom-connection-troubleshooting-guide#h_ff7008544e'
  },
  [EVENT_LINK_ERROR_CODE]: {
    type: ZOOM_VALIDATION_ERROR,
    reason: 'Event Link Entered',
    errorCode: EVENT_LINK_ERROR_CODE,
    message: 'This is a Zoom Events link. Please enter a meeting or webinar link.',
    helpUrl: 'https://help.streamalive.com/en/articles/11332308-streamalive-zoom-connection-troubleshooting-guide#h_afb22da341'
  }
};
